import React from 'react';
import { Button, message } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { guidelineNames, printRackLabels } from '../../utils/printRackLabels';

export default function RackLabelsTitle({ title, mergeIds }) {
    const print = event => {
        event.stopPropagation();
        const names = guidelineNames(mergeIds);
        if (!names.length) {
            message.warning('No guidelines to print');
            return;
        }
        if (!printRackLabels(names)) message.error('Allow pop-ups to print rack labels');
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                paddingRight: 28,
            }}
        >
            <span style={{ minWidth: 0 }}>{title}</span>
            <Button size="small" icon={<PrinterOutlined />} onClick={print} style={{ flexShrink: 0 }}>
                Print Rack Labels
            </Button>
        </div>
    );
}
